/* True North Paws — full PDP stability/performance hotfix */
(function(){
  'use strict';

  function patchProductInfo(){
    if(!window.customElements||!customElements.whenDefined)return;
    customElements.whenDefined('product-info').then(function(){
      var Ctor=customElements.get('product-info');
      if(!Ctor||!Ctor.prototype||Ctor.prototype.__tnpAuditPatched)return;
      var proto=Ctor.prototype;
      proto.__tnpAuditPatched=true;

      /* Stop the duplicate full-page request on every variant change. */
      proto.updateQuantityBreakBlocks=function(html){
        try{
          var product=this.closest('.product');
          if(!product||!html)return;
          product.querySelectorAll('.lumin-product-block-qty-break').forEach(function(elem){
            var id=elem.dataset&&elem.dataset.blockId;
            if(!id)return;
            var fresh=html.getElementById('lumin-product-block-qty-break-'+id);
            if(fresh)elem.replaceWith(fresh);
          });
        }catch(err){console.warn('TNP quantity-block update recovered',err);}
      };

      /* A missing quantity form in a section response used to throw and could stop the rest of the PDP update. */
      if(typeof proto.updateQuantityRules==='function'){
        var originalQuantityRules=proto.updateQuantityRules;
        proto.updateQuantityRules=function(sectionId,html){
          try{
            if(!html||!html.getElementById||!html.getElementById('Quantity-Form-'+sectionId))return;
            return originalQuantityRules.call(this,sectionId,html);
          }catch(err){console.warn('TNP quantity-rules update recovered',err);}
        };
      }

      /* Keep price/variant UI alive even if a gallery item or thumbnail is missing. */
      if(typeof proto.updateMedia==='function'){
        var originalUpdateMedia=proto.updateMedia;
        proto.updateMedia=function(html,mediaId){
          try{return originalUpdateMedia.call(this,html,mediaId);}
          catch(err){console.warn('TNP media update recovered',err);}
        };
      }
    }).catch(function(){});
  }

  function patchQtyBreak(){
    if(!window.customElements||!customElements.whenDefined)return;
    customElements.whenDefined('lumin-product-qty-break').then(function(){
      var Ctor=customElements.get('lumin-product-qty-break');
      if(!Ctor||!Ctor.prototype||Ctor.prototype.__tnpAuditPatched)return;
      Ctor.prototype.__tnpAuditPatched=true;

      /* Remove already-attached listeners that fetched the whole product page again. */
      document.querySelectorAll('lumin-product-qty-break').forEach(function(el){
        if(el._variantChangeHandler){
          document.removeEventListener('variant:change',el._variantChangeHandler);
          el._variantChangeHandler=null;
        }
      });
      Ctor.prototype.handleVariantChange=function(){};
    }).catch(function(){});
  }

  function patchMediaGallery(){
    if(!window.customElements||!customElements.whenDefined)return;
    customElements.whenDefined('media-gallery').then(function(){
      var Ctor=customElements.get('media-gallery');
      if(!Ctor||!Ctor.prototype||Ctor.prototype.__tnpAuditPatched)return;
      var proto=Ctor.prototype;
      proto.__tnpAuditPatched=true;

      /* Do not reassign image.src to itself just to announce an image. */
      proto.announceLiveRegion=function(activeItem,position){
        try{
          var image=activeItem&&activeItem.querySelector('.product__modal-opener--image img');
          if(!image||!this.elements||!this.elements.liveRegion)return;
          var self=this;
          function announce(){
            self.elements.liveRegion.setAttribute('aria-hidden','false');
            if(window.accessibilityStrings&&window.accessibilityStrings.imageAvailable){
              self.elements.liveRegion.innerHTML=window.accessibilityStrings.imageAvailable.replace('[index]',position||'');
            }
            setTimeout(function(){if(self.elements&&self.elements.liveRegion)self.elements.liveRegion.setAttribute('aria-hidden','true');},1200);
          }
          if(image.complete)announce();
          else image.addEventListener('load',announce,{once:true});
        }catch(err){}
      };

      if(typeof proto.setActiveMedia==='function'){
        var originalSetActiveMedia=proto.setActiveMedia;
        proto.setActiveMedia=function(){
          try{return originalSetActiveMedia.apply(this,arguments);}
          catch(err){console.warn('TNP gallery switch recovered',err);}
        };
      }
    }).catch(function(){});
  }

  function optimizeProductImages(){
    var images=document.querySelectorAll('.template-product .product__media img,.template-product .product-media img,.template-product .product__media-item img');
    if(!images.length)return;
    images.forEach(function(img,index){
      try{
        img.decoding='async';
        if(index===0){img.loading='eager';img.fetchPriority='high';}
        else{img.loading='lazy';img.fetchPriority='low';}
      }catch(err){}
    });
  }

  patchProductInfo();
  patchQtyBreak();
  patchMediaGallery();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',optimizeProductImages,{once:true});
  else optimizeProductImages();
})();
